
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppComponent } from './app.component';
import { ContentLayoutComponent } from './layouts/content/content-layout.component';
import { FullLayoutComponent } from './layouts/full/full-layout.component';

import { CoreModule } from './core/core.module';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import Swal from 'sweetalert2';
import { MachineService } from './machine/services/machine.service';
import { ClientService } from './client/services/client.service';
import { ConcessionaireService } from './concessionaire/services/concessionaire.service';
import { SellerService } from './seller/services/seller.service';
import { WorkplanService } from './workplan/services/workplan.service';
import { AssemblyOrderService } from './assembly-order/services/assembly-order.service';


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


  @NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule,
        CoreModule,
        NgbModule,
        SweetAlert2Module.forRoot({
            // ngx-sweetalert2 v7+ sets global defaults via a Swal.mixin provider
            provideSwal: () => Promise.resolve(Swal.mixin({
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn white mr-4',
                    cancelButton: 'btn white'
                }
            }))
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        }),
        FullLayoutComponent, ContentLayoutComponent
    ],
    exports: [
        CoreModule,
        SweetAlert2Module
    ],
    providers: [
        MachineService,
        ClientService,
        ConcessionaireService,
        SellerService,
        WorkplanService,
        AssemblyOrderService,
        provideHttpClient(withInterceptorsFromDi())
    ],
    bootstrap: [AppComponent]
})
  export class AppModule {}
